import { render, staticRenderFns } from "./PalletMove.vue?vue&type=template&id=79e5757e"
import script from "./PalletMove.vue?vue&type=script&lang=js"
export * from "./PalletMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports